import { ReservationActionsUnion, ReservationActionTypes } from '../actions/reservation.action';
import { ProductReservation } from '@vestiaire/api-sdk-angular';

export interface State {
  status: ProductReservation | null;
  productId: string | null;
}

export const initialState: State = {
  status: null,
  productId: null
};

export function reducer(state = initialState, action: ReservationActionsUnion) {
  switch (action.type) {
    case ReservationActionTypes.CheckReservation:
      return initialState;

    case ReservationActionTypes.CheckReservationSuccess:
      return {
        ...state,
        status: action.payload.reservation,
        productId: action.payload.productId
      };

    case ReservationActionTypes.CancelReservation:
      if (action.payload.productId === state.productId) {
        return initialState;
      }
      return state;

    case ReservationActionTypes.ClearReservation:
      return {
        ...state,
        status: null,
        productId: null
      };

    default:
      return state;
  }
}

export const getReservationStatus = (state: State) => state.status;
